/*global isApp */
/******************************************
 * ssg
 *
 * @author          Luke.kim
 * @copyright       Copyright (c) 2013 emart.
 * @license         This is dual licensed under the MIT and GPL licenses.
 * @version         0.1
 * @description     전몰에서 공통으로 사용하는 모듈만 등록
 * @since           2014-08-19 15:30
 * @modify          2014-09-23 17:02
 * @history         0.2     ScrollBanner플러그인 추가
 * @uses jindo.m.LayerPosition
 *
 ******************************************/
( function( $, window, document ) {
    'use strict';

    var pluginName = 'layerPosition',
        defaults = {
            bActivateOnload: true,
            bAutoReposition: true,
            sPosition: "center",
            nLeftMargin: 0,
            nRightMargin: 0,
            nTopMargin: 0,
            nBottomMargin: 0,
            bUseFixed: true
        };

    function LayerPosition( element, options ) {
        this.el = element;
        this.wel = $( element );
        this.options = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;

        this.init( );
    }

    LayerPosition.prototype = {
        init: function( ) {
            this._initLayerPosition( );
            this._attachLayerPositionEvent( );
        },
        _initLayerPosition: function( ) {
            this._oLayerPosition = new jindo.m.LayerPosition( this.el, this.options );
        },
        _attachLayerPositionEvent: function( ) {
            this._oLayerPosition.attach( 'beforePosition', $.proxy( this._onBeforePosition, this ) );
            this._oLayerPosition.attach( 'position ', $.proxy( this._onPosition, this ) );
        },
        _onBeforePosition: function( oCustomEvt ) {
            this._triggerEvent( oCustomEvt );
        },
        _onPosition: function( oCustomEvt ) {
            this._triggerEvent( oCustomEvt );
        },
        _triggerEvent: function( oCustomEvt ) {
            this.wel.trigger( oCustomEvt.sType, [ oCustomEvt ] );
        },
        all: function( ) {
            this._oLayerPosition.all( );
        },
        top: function( ) {
            this._oLayerPosition.top( );
        },
        center: function( ) {
            this._oLayerPosition.center( );
        },
        bottom: function( ) {
            this._oLayerPosition.bottom( );
        }
    };
    $.fn[ pluginName ] = function( options ) {
        return this.each( function( ) {
            if( !$.data( this, "plugin_" + pluginName ) ) {
                $.data( this, "plugin_" + pluginName, new LayerPosition( this, options ) );
            } else if( $.isFunction( LayerPosition.prototype[ options ] ) ) {
                $.data(this, 'plugin_' + pluginName)[options].apply();
            }
        } );
    };
} )( jQuery, window, document );


( function( $, window, document ) {
    'use strict';

    var pluginName = 'scrollBanner',
        defaults = {
            nPageTop: 5,
            sAppBanner : 'fixed_ban_app',
            sScrollBanner : 'fixed_ban_extend'
        };

    function ScrollBanner( element, options ) {
        this.el = element;
        this.wel = $( element );
        this.welWindow = $( window );
        this.options = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;

        this.init( );
    }

    ScrollBanner.prototype = {
        init: function( ) {
            this._bApp = (typeof isApp !== 'undefined') ? ((isApp==='Y') ? true : false) : false;
            this._attachScrollBannerEvent( );

            if(this._bApp){
                this.wel.addClass(this.options.sAppBanner);
            }
        },
        _attachScrollBannerEvent: function( ) {
            this.welWindow.on('scroll.spy', $.proxy( this._onScrollWindow, this ));
        },
        _onScrollWindow: function(){
            if(this.options.nPageTop > this.welWindow.scrollTop()){
                this._slidingUpProduct();
            }else{
                this._slidingDownProduct();
            }
        },
        _slidingUpProduct: function(){
            this.wel.removeClass(this.options.sScrollBanner);
        },
        _slidingDownProduct: function(){
            this.wel.addClass(this.options.sScrollBanner);
        }
    };
    $.fn[ pluginName ] = function( options ) {
        return this.each( function( ) {
            if( !$.data( this, "plugin_" + pluginName ) ) {
                $.data( this, "plugin_" + pluginName, new ScrollBanner( this, options ) );
            } else if( $.isFunction( ScrollBanner.prototype[ options ] ) ) {
                $.data(this, 'plugin_' + pluginName)[options].apply();
            }
        } );
    };
} )( jQuery, window, document );


$(function(){
    //var welChannelBanner = $('#floating_channel_ban');
    // fixed banner for channel
    /*$('#floating_channel_ban').layerPosition({
        sPosition: 'bottom',
        nBottomMargin: 222
    });*/
    $("#com_extend_ban").scrollBanner();
});